import Can from '../Can';
import { NavLink } from 'react-router-dom';
// IMPORT PACKAGE REFERENCES
import React from 'react';
// IMPORT PROJECT REFERENCES
import osano from '../../images/osano_logo.png';

// COMPONENT
export const Header = () => (
    <div>
        <nav className="navbar navbar-expand-lg navbar-light">
            <a className="navbar-brand" href="/">
                <img className="m-3" height="15" src={osano} alt="Home" />
            </a>
            <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#menu"
            >
                <span className="navbar-toggler-icon" />
            </button>

            <div className="collapse navbar-collapse" id="menu">
                <ul className="navbar-nav mr-auto">
                    <li className="nav-item">
                        <div className="nav-link">
                            <NavLink to="/" activeClassName="menu selected" exact={true}>
                                Home
                            </NavLink>
                        </div>
                    </li>
                    <Can I="read" a="Customer">
                        <li className="nav-item">
                            <div className="nav-link">
                                <NavLink to="/customers" activeClassName="menu selected">
                                    Customers
                                </NavLink>
                            </div>
                        </li>
                    </Can>
                    <Can I="create" a="Analysis">
                        <li className="nav-item">
                            <div className="nav-link">
                                <NavLink to="/analyses" activeClassName="menu selected">
                                    Analyses
                                </NavLink>
                            </div>
                        </li>
                    </Can>
                </ul>
            </div>
        </nav>
    </div>
);
